import React from 'react';
import { Eye } from 'lucide-react';
import LegalDoc, { LegalDocData } from '../components/LegalDoc';
import legal from '../content/legal.json';

export default function PrivacyPolicy() {
  return <LegalDoc doc={legal.privacy as LegalDocData} icon={<Eye className="w-5 h-5 text-zinc-400" />} />;
}
